import { lenis } from './scroll';

// As the next project scrolls over a stuck one, blur the outgoing image
// and fade its caption. Desktop only — mobile items are not sticky.
const mq = window.matchMedia('(min-width: 900px)');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.addEventListener('DOMContentLoaded', () => {
    const projects = [...document.querySelectorAll('.page-home .project')];

    if (projects.length < 2) return;

    const parts = projects.map((project) => ({
        media: project.querySelector('.project__media'),
        desc: project.querySelector('.project__desc'),
    }));

    const reset = () => {
        parts.forEach(({ media, desc }) => {
            if (media) media.style.filter = '';
            if (media) media.style.opacity = '';
            if (desc) desc.style.opacity = '';
        });
    };

    const update = () => {
        if (!mq.matches || reduceMotion.matches) return;

        const headerSize = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue('--header-size')
        ) || 79;
        const range = window.innerHeight * 0.5;

        for (let i = 0; i < projects.length - 1; i++) {
            const nextTop = projects[i + 1].getBoundingClientRect().top;
            const progress = Math.min(1, Math.max(0, 1 - (nextTop - headerSize) / range));
            const { media, desc } = parts[i];

            if (media) {
                media.style.filter = progress > 0 ? `blur(${(progress * 12).toFixed(2)}px)` : '';
                media.style.opacity = progress > 0 ? `${(1 - progress * 0.35).toFixed(3)}` : '';
            }
            if (desc) {
                desc.style.opacity = progress > 0 ? `${(1 - progress).toFixed(3)}` : '';
            }
        }
    };

    lenis.on('scroll', update);
    window.addEventListener('resize', update);
    mq.addEventListener('change', () => (mq.matches ? update() : reset()));
    update();
});
